import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import { api } from '@/f1/service';
import codes from '@/f1/codes';
import Language from './language';

//i18n_data
import fields from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, Language },
  data: () => ({ custom, so : default_opt(), search_type : '', codes }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() { return fields.i18n_fields[this.i18n || 'EN']; },
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'title,question',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { target: 'qna', cmd : 'list',limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [{ name : 'id', op : 'desc'}] } }
      // order
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      if(this.search_type != '') { search.body.and.push({ name : "type", value : this.search_type, op : "=" }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.and.push({"name": key, "value": `%${value}%`, "op": 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'title' : search.body.and.push({name : 'title', value : `%${value}%`, op : 'like'}); break;
          case 'question' : search.body.and.push({name : 'question', value : `%${value}%`, op : 'like'}); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'answered_at_st' : search.body.and.push({name: 'answered_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'answered_at_ed' : search.body.and.push({name: 'answered_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: value.replace(/\*/g, '%'), op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }

      try { let rs = await api.board.Board(search); this.so.totalRows = rs.total; return rs.body; }
      catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data || e); }
    },
    detail(item) { this.$router.push(`qna/${item.id}`); },
  },
  created() { console.log('[vue] qna.list', 'created'); },
  destroyed() { console.log('[vue] qna.list', 'destroyed'); },
  mounted() { console.log('[vue] qna.list', 'mounted'); },
}
